import { Trans } from "react-i18next";

import util from "utils/utils";

import type { NotificationContentProps } from "../../types";

export default function ChallengeAddedToCalendar({
  events = [],
  ownerIdea,
  ownerChallenge,
  ownerGroup,
  context,
  status,
}: NotificationContentProps) {
  return (
    <Trans
      i18nKey="notifications.challengeAddedToCalendarEvent"
      values={{
        events: util.getCalendarEventNames(events),
        challenge: ownerChallenge?.name || "Deleted",
      }}
    />
  );
}
